import {FC} from 'react'

import {TriangleWarningIcon} from '../SvgIcon'
import {useTranslation} from 'react-i18next'
import {LoadingSpinner, RenderIf} from 'components'
import {colorCodes} from 'definitions/constant'

interface RouterProps {
  onOK: () => void
  onCancel: () => void
  title?: string
  okText?: string
  cancelText?: string
  ariaLabel?: string
  isConfirming?: boolean
}

export const RouterPrompt: FC<RouterProps> = props => {
  const {t} = useTranslation('common')
  const {
    onOK,
    onCancel,
    title = 'Are you sure you want to leave this page? You have unsaved changes.',
    okText = 'Confirm',
    cancelText = 'Cancel',
    ariaLabel = t('CONFIRMATION_DIALOG'),
    isConfirming = false,
  } = props

  return (
    <div
      className="w-full h-full z-50 bg-dope-black bg-opacity-30 fixed flex justify-center items-start mt-4 top-0 left-0 right-0 bottom-0"
      role="dialog"
    >
      <div className="max-w-md p-5 rounded-md shadow-2xl bg-gray-900">
        <div className="w-full flex items-start justify-between">
          <TriangleWarningIcon
            width={40}
            height={40}
            strokeColor="#e1aa0e"
            classes="-mt-1"
          />
          <h1
            data-cy="router-prompt-title-message"
            className="text-white text-base text-left karla-exl ml-4"
          >
            {title}
          </h1>
        </div>

        <div className="mt-12 flex items-center justify-end">
          <button
            className="mr-7 text-sm"
            onClick={onCancel}
            data-cy="router-prompt-cancel-button"
            aria-label={t('CANCEL')}
          >
            {cancelText}
          </button>

          <RenderIf isTrue={!isConfirming}>
            <button
              className="text-sm"
              onClick={onOK}
              data-cy="router-prompt-ok-button"
              aria-label={ariaLabel}
            >
              {okText}
            </button>
          </RenderIf>

          <RenderIf isTrue={isConfirming}>
            <LoadingSpinner
              isLoading={true}
              type="TailSpin"
              color={colorCodes.white}
              width={16}
              height={16}
              ariaLabel="default bypass scanning spinner"
            />
          </RenderIf>
        </div>
      </div>
    </div>
  )
}
